/**
 * 组织架构apiapi
 * date:2022 05 25
 */
import httpRequest from '@/utils/request.js';

/** 新增组织架构接口 */
export const sceneAddScene = data => httpRequest.httpPost('/service/scene/addScene', data);
/** 新增组织架构平面图接口 */
export const sceneAddScenePlan = (data, loadingOptions) => httpRequest.httpForm('/service/scene/plan/add', data, loadingOptions);
/** 新增组织架构地图接口 */
export const sceneAddSceneMap = data => httpRequest.httpPost('/service/scene/map/add', data);
/** 获取系统生成的架构编码接口 */
export const sceneGetGeneSceneCode = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/scene/getGeneSceneCode',
        params: {
            ...params
        }
    });
/** 获取组织架构类型参数接口 -- 弃用 */
// export const paramContentList = (params = {}) => httpRequest.httpGet({
//     url: '/service/param/content/list', params: {
//         ...params
//     }
// })
/** 获取地图架构信息接口 */
export const sceneGetMapDetail = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/scene/getMapDetail',
        params: {
            ...params
        }
    });
/** 获取平面图信息接口 */
export const sceneGetPlanDetail = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/scene/getPlanDetail',
        params: {
            ...params
        }
    });
/** 通过架构id获取载体列表接口 */
export const carrierGetCarrierBySceneId = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/carrier/getCarrierBySceneId',
        params: {
            ...params
        }
    });
/** 获取平面图监测点详细信息接口 */
export const sceneGetCarrierPositionInfo = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/scene/getCarrierPositionInfo',
        params: {
            ...params
        }
    });
/** 通过架构id校验是否是平面图接口 */
export const checkPaneScene = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/home/scene/isPlane',
    params: {
      ...params
    }
  });
/** 拖拽排序接口 */
export const sceneDragSort = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/scene/dragSort',
        params: {
            ...params
        }
    });
/** 删除架构信息接口 */
export const sceneDelScene = data => httpRequest.httpdelete('/service/scene/delScene', data);
/** 更新地图架构信息接口 */
export const sceneSaveLatLng = data => httpRequest.httpPost('/service/scene/saveLatLng', data);
/** 更新架构信息接口 */
export const sceneUptScene = data => httpRequest.httpPut('/service/scene/uptScene', data);
/** 上传平面图接口 */
export const sceneupload = (data, loadingOptions) => httpRequest.httpForm('/service/scene/upload', data, loadingOptions);
/** 删除平面图接口 */
export const sceneDelPos = data => httpRequest.httpdelete('/service/scene/pos/del', data);
/** 保存坐标接口 */
export const scenePosMerge = data => httpRequest.httpPut('/service/scene/pos/merge', data);

/** 获取平面图定位监测点接口 */
export const getBindCarrierPosition = (param) =>
  httpRequest.httpGet({
    url: '/service/home/scene/position/carrier/bind/' + param
  });
/** 获取平面图绑定定位设备接口 */
export const getBindDevicePosition = (param) =>
  httpRequest.httpGet({
    url: '/service/home/scene/position/device/bind/' + param
  });
/** 获取平面图未绑定定位设备接口 */
export const getUnBindDevicePosition = params => httpRequest.httpGet({
  url :'/service/home/scene/position/device/unBind',
  params: {
    ...params
  }
});
/** 保存设备坐标接口 */
export const saveDevicePosition = data => httpRequest.httpPost('/service/scene/save/device/pos', data);
/** 删除平面图接口 */
export const deleteDevicePosition = params => httpRequest.httpdelete(
    '/service/home/scene/device/position/delete',
    { ...params }
);
/** 获取地图架构信息接口 */
export const getHomeMapPosition = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/home/map/position',
    params: {
      ...params
    }
  });
